import {
  NBS_API_GET_QUICK_MATCHES_SUCCESS,
  NBS_API_INVITE_ACTION_SUCCESS,
  NBS_API_GET_ADS_SUCCESS,
  SET_QUICK_MATCHES_ADS,
  SET_SHOWING_INDEX_QUICK_MATCH_AD,
} from '../../constants/actions';

const initialState = {
  ads: [],
  data: [],
  showStartOver: undefined,
  currentQuickMatchIndex: 0,
  undoUserId: null,
  matchedUser: {},
  indexOfLastShowedAd: -1,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_QUICK_MATCHES_SUCCESS:
      const currentState = { ...state };
      const { matches } = action.response;
      return {
        ...currentState,
        showStartOver: action.response.show_start_over,
        data: action.startOver ? matches : [...currentState.data, ...matches],
        indexOfLastShowedAd: -1,
      };
    case NBS_API_INVITE_ACTION_SUCCESS:
      const invCurrentState = { ...state };
      let newCurrentQuickMatchIndexOnInviteActionSuccess;
      let undoUserIdOnInviteActionSuccess = null;
      if (action.data.user_action === 3) {
        newCurrentQuickMatchIndexOnInviteActionSuccess =
          invCurrentState.currentQuickMatchIndex > 0
            ? invCurrentState.currentQuickMatchIndex - 1
            : 0;
      } else {
        newCurrentQuickMatchIndexOnInviteActionSuccess =
          invCurrentState.currentQuickMatchIndex + 1;
        undoUserIdOnInviteActionSuccess = action.data.user_id;
      }
      return {
        ...invCurrentState,
        currentQuickMatchIndex: newCurrentQuickMatchIndexOnInviteActionSuccess,
        undoUserId: undoUserIdOnInviteActionSuccess,
      };
    case NBS_API_GET_ADS_SUCCESS:
      return {
        ...state,
        indexOfLastShowedAd: -1,
      };
    case SET_SHOWING_INDEX_QUICK_MATCH_AD:
      return {
        ...state,
        indexOfLastShowedAd: action.index,
      };
    case SET_QUICK_MATCHES_ADS:
      return {
        ...state,
        ads: [...state.ads, ...action.data],
      };
    default:
      return state;
  }
}
